import { Button, Col, DatePicker, Input, message, Modal, Popconfirm, Radio, Row, Select, Space, Table } from "antd"
import moment from "moment"
import { Fragment, useEffect, useState } from "react"
import { useParams } from "react-router"
import { baseAxiosNoInfo, baseAxiosComplete } from "../../tool/axios"
import { ExclamationOutlined, DeleteOutlined } from '@ant-design/icons'
import _ from "lodash"

const { Option } = Select
const { Column } = Table

type backendStepDataType = {
    stage_number: number | undefined,
    stage_desc: string | undefined,
    high_price_item_count: number,
    detail: {
        which_date: string
        which_day: number,
        meal_times: number,
        menu_item_list: {
            is_high_price: number | undefined,
            menu_item_name: string | undefined,
            menu_item_id: string | undefined,
            menu_item_count: number
        }[]
    }[]
}[]

type itemRow = {
    is_high_price: number | undefined,
    menu_item_name: string | undefined,
    menu_item_id: string | undefined,
    menu_item_count: number
}

type reviewType = {
    stageDesc: string | undefined
    detail: {
        date: string,
        meals1: itemRow[],
        meals2: itemRow[],
        meals3: itemRow[],
        meals4: itemRow[],
        meals5: itemRow[],
        meals6: itemRow[],
    }[]
}

export default function () {

    const params: { check_in_id: string } = useParams()
    const [types, setTypes] = useState<any[]>([])
    const [foods, setFoods] = useState<any[]>([])
    const [foodID1, setFoodID1] = useState<string[]>([])
    const [foodID2, setFoodID2] = useState<string[]>([])
    const [pgid, setPgid] = useState<string>()
    const [gestationDesc, setGestationDesc] = useState<string>()
    const [otherException, setOtherException] = useState<string>()
    const [pgDetail, setPgDetail] = useState<any>({
        assess_id: undefined, //评估id，其他接口可能会用到
        assess_date: undefined, //评估日期
        gestation_desc: undefined, //妊娠并发症
        guomin_food_item_name: undefined, //过敏食材名称，多个用英文逗号拼接
        guomin_food_item_id: undefined, //过敏食材id，多个用英文逗号拼接
        jinji_food_item_name: undefined, //禁忌食材id，多个用英文逗号拼接
        jinji_food_item_id: undefined, //禁忌食材id，多个用英文逗号拼接
        other_exception: undefined, //其他异常
    })
    const [assessDate, setAssessDate] = useState<any>(null)

    const [hadFill, setHadFill] = useState<number>(0)
    const [showEditPage, setShowEditPage] = useState<boolean>(false)
    const [showHistoryPage, setShowHistoryPage] = useState<boolean>(false)
    const [standardMeals, setStandardMeals] = useState<{
        template_id: string, template_name: string
    }[]>([])
    const [standanrdApplyID, setStandanrdApplyID] = useState<string>() // 标准餐单id
    const [standardMealsData, setSandardMealsData] = useState<backendStepDataType[]>()
    const [currentStageIndex, setCurrentStageIndex] = useState<number>(0)

    const [sugarStatus, setSugarStatus] = useState<number>()
    const [saltStatus, setSaltStatus] = useState<number>()
    const [preferenceDesc, setPreferenceDesc] = useState<string>()
    const [curentCpIndex, setCurrentCpIndex] = useState<number>(0)
    const [currentMealKey, setCurrentMealKey] = useState<string>()

    const [useDate, setUseDate] = useState<any>()

    const [hadPgData, setHadPgData] = useState<boolean>(false)
    const [phVisibled, setVisibled] = useState<boolean>(false)

    const [reviewData, setReviewData] = useState<reviewType[]>([])
    let everyDayMeals = {
        meals1: [
            {
                foodName: '',
                count: 0
            }
        ],
        meals2: [
            {
                foodName: '',
                count: 0
            }
        ],
        meals3: [
            {
                foodName: '',
                count: 0
            }
        ],
        meals4: [
            {
                foodName: '',
                count: 0
            }
        ],
        meals5: [
            {
                foodName: '',
                count: 0
            }
        ],
        meals6: [
            {
                foodName: '',
                count: 0
            }
        ],
    }

    function historyToRenderData(data: backendStepDataType): reviewType[] {
        let result: reviewType[] = []

        for (let i = 0; i < data.length; i++) {
            let dayDetailArr: any = []

            for (let j = 0; j < data[i].detail.length; j++) {
                let iDetail = data[i].detail[j]
                if (!(dayDetailArr.some((el: any) => el.date === iDetail.which_date))) {
                    let meals1: itemRow[] = []
                    let meals2: itemRow[] = []
                    let meals3: itemRow[] = []
                    let meals4: itemRow[] = []
                    let meals5: itemRow[] = []
                    let meals6: itemRow[] = []
                    if (iDetail.meal_times === 1) {
                        meals1 = iDetail.menu_item_list
                    }
                    if (iDetail.meal_times === 2) {
                        meals2 = iDetail.menu_item_list
                    }
                    if (iDetail.meal_times === 3) {
                        meals3 = iDetail.menu_item_list
                    }
                    if (iDetail.meal_times === 4) {
                        meals4 = iDetail.menu_item_list
                    }
                    if (iDetail.meal_times === 5) {
                        meals5 = iDetail.menu_item_list
                    }
                    if (iDetail.meal_times === 6) {
                        meals6 = iDetail.menu_item_list
                    }
                    dayDetailArr.push({
                        date: data[i].detail[j].which_date,
                        meals1,
                        meals2,
                        meals3,
                        meals4,
                        meals5,
                        meals6,
                    })
                } else {
                    let hadIndex = dayDetailArr.findIndex(((el: any) => el.date === iDetail.which_date))
                    dayDetailArr[hadIndex]['meals' + iDetail.meal_times].push(...iDetail.menu_item_list)
                }
            }

            result.push({
                stageDesc: data[i].stage_desc,
                detail: dayDetailArr
            })
        }

        return result
    }


    const [menuDate, setMenuDate] = useState<any>()
    const [oneDayMeals, setOneDayMeals] = useState<any>({
        menu_date: '',
        menu_start_date: '',
        menu_end_date: '',
        menu_info: {
            zao_can: [],
            jia_can: [],
            wu_can: [],
            jian_can: [],
            wan_can: [],
            xiaoye: [],
        },
        already_order_and_add_info: {
            add: [],
            order: []
        },
    })

    useEffect(() => {
        // 查询是否有餐单记录
        baseAxiosNoInfo('/cooking_center/customer/menu/has_menu', {
            params: {
                check_in_id: params.check_in_id
            }
        }).then((res: any) => {
            setHadFill(res)

            if (res === 1) { // 有记录则查询详情
                baseAxiosNoInfo('/cooking_center/customer/menu/detail', {
                    params: {
                        check_in_id: params.check_in_id
                    }
                }).then((res2: any) => {
                    setShowHistoryPage(true)
                    setReviewData(historyToRenderData(res2.stage))
                    setSandardMealsData(res2.stage)
                })
            }
        })

        // 查询标准餐单列表
        baseAxiosNoInfo('/cooking_center/customer/menu/template_menu_list', {
            params: {
                check_in_id: params.check_in_id
            }
        }).then((res: any) => {
            res && setStandardMeals(res)
        })

        // 查询食材分类
        baseAxiosNoInfo('/cooking_center/global/food_type_list').then((res: any) => {
            res && setTypes(res)
        })

        // 查询评估详情
        baseAxiosNoInfo('/cooking_center/customer/dietician_assess/detail', {
            params: {
                check_in_id: params.check_in_id,
            }
        }).then((res: any) => {
            if (res) {
                setAssessDate(res.assess_date)
                setGestationDesc(res.gestation_desc)
                setOtherException(res.other_exception)
                setPgid(res.assess_id)
                setHadPgData(true)
                setPgDetail(res)
            } else {
                setHadPgData(false)
            }
        })

        // 查询单日的餐单
        baseAxiosNoInfo('/cooking_center/customer/food_plan/menu_info_by_date', {
            params: {
                check_in_id: params.check_in_id,
                menu_date: menuDate ? menuDate.format('YYYY-MM-DD') : ''
            }
        }).then((res: any) => {
            if (res) {
                setOneDayMeals(res)
                setMenuDate(res.menu_date)
            }
        })

        // 查询菜品
        baseAxiosNoInfo('/cooking_center/global/menu_type_list').then((res: any) => {
            res && setFoodTypeList(res)
        })
    }, [])

    const editPg = () => {

        baseAxiosComplete.post('/cooking_center/customer/dietician_assess/update', {
            assess_id: pgid,//评估id，“营养膳食-营养评估-查询详情”接口返回的assess_id字段
            assess_date: assessDate,//评估日期
            gestation_desc: gestationDesc,//妊娠并发症
            guomin_food_item_id: foodID2,//过敏食材id，多个用英文逗号拼接
            jinji_food_item_id: foodID1,//禁忌食材id，多个用英文逗号拼接
            other_exception: otherException,//其他异常
        }).then((res: any) => {
            // 查询单日的餐单
            baseAxiosNoInfo('/cooking_center/customer/food_plan/menu_info_by_date', {
                params: {
                    check_in_id: params.check_in_id,
                    menu_date: menuDate ? moment(menuDate).format('YYYY-MM-DD') : ''
                }
            }).then((res: any) => {
                if (res) {
                    setOneDayMeals(res)
                    setMenuDate(res.menu_date)
                }
            })
        })
    }

    const [foodTypeList, setFoodTypeList] = useState<{
        menu_type_id: string,
        menu_type_name: string
    }[]>([])
    const [foodList, setFoodList] = useState<{
        menu_item_id: string,
        menu_item_name: string,
        is_high_price: number
    }[]>([])
    const [food, setFood] = useState<{
        menu_item_id: string,
        menu_item_name: string,
        is_high_price: number
    }>()

    const phOk = () => {
        if (currentMealKey) {
            let d = _.cloneDeep(oneDayMeals)
            d.menu_info[currentMealKey][curentCpIndex].sugar_status = sugarStatus
            d.menu_info[currentMealKey][curentCpIndex].salt_status = saltStatus
            d.menu_info[currentMealKey][curentCpIndex].preference_desc = preferenceDesc
            setOneDayMeals(d)
            setVisibled(false)
        }
    }

    const phCancel = () => {
        setVisibled(false)
    }

    return <div style={{
        background: '#fff', marginTop: 16, padding: 16
    }}>
        <Button size="small" onClick={() => { window.history.go(-1) }} style={{ marginBottom: 16 }}>返回</Button>

        <div>
            <Space>
                <DatePicker placeholder="用餐日期" value={menuDate ? moment(menuDate) : null} onChange={(v: any) => {
                    setMenuDate(v)
                    baseAxiosNoInfo('/cooking_center/customer/food_plan/menu_info_by_date', {
                        params: {
                            check_in_id: params.check_in_id,
                            menu_date: v ? v.format('YYYY-MM-DD') : null
                        }
                    }).then((res: any) => {
                        if (res) {
                            setOneDayMeals(res)
                        } else { // 无数据

                        }
                    })
                }} />
                {/* <Button>重置</Button> */}
                <Popconfirm
                    title="应检查是否带有过敏或禁忌菜品，是否确认保存？"
                    onConfirm={() => {
                        baseAxiosComplete.post('/cooking_center/customer/food_plan/save', {
                            check_in_id: params.check_in_id,
                            menu_date: menuDate ? moment(menuDate).format('YYYY-MM-DD') : null,
                            menu_info: oneDayMeals.menu_info,
                        }).then((res => {
                            baseAxiosNoInfo('/cooking_center/customer/menu/detail', {
                                params: {
                                    check_in_id: params.check_in_id
                                }
                            }).then((res2: any) => {
                                setShowHistoryPage(true)
                                setReviewData(historyToRenderData(res2.stage))
                                setSandardMealsData(res2.stage)
                            })
                        }))
                    }}
                >
                    <Button>保存</Button>
                </Popconfirm>

                <Popconfirm
                    title="应检查是否带有过敏或禁忌菜品，是否确认下单？"
                    onConfirm={() => {
                        // 先提交一次保存
                        baseAxiosComplete.post('/cooking_center/customer/food_plan/save', {
                            check_in_id: params.check_in_id,
                            menu_date: menuDate ? moment(menuDate).format('YYYY-MM-DD') : null,
                            menu_info: oneDayMeals.menu_info,
                        }).then((res => {
                            baseAxiosComplete.post('/cooking_center/customer/food_plan/order', {
                                check_in_id: params.check_in_id,
                                menu_date: menuDate ? moment(menuDate).format('YYYY-MM-DD') : null,
                            }).then((res => {

                            }))
                        }))
                    }}
                >
                    <Button>确认下单</Button>
                </Popconfirm>

            </Space>
        </div>

        <Row style={{ marginTop: 20 }} gutter={32}>
            <Col span="4">
                <h4>营养评估</h4>

                {!hadPgData && <p style={{ marginTop: 16 }}>暂无营养评估数据，请在客户详情页添加数据</p>}

                {hadPgData && <Fragment>
                    <div style={{ marginTop: 16 }}>
                        <p>
                            评估日期{assessDate}
                            {/* <DatePicker value={assessDate} onChange={(v:any)=>{
                        setAssessDate(v)
                    }} placeholder="评估日期"/> */}
                        </p>
                        <p><Input placeholder="妊娠并发症" value={gestationDesc} onChange={(v: any) => {
                            setGestationDesc(v.target.value)
                        }} /></p>
                    </div>
                    {/* 之前已选禁忌食材 */}
                    <div style={{ marginTop: 16, color: 'orange' }} >之前已选禁忌食材：{pgDetail.jinji_food_item_name}</div>
                    {/* 之前已选过敏食材 */}
                    <div style={{ marginTop: 16, color: 'orange' }} >之前已选过敏食材：{pgDetail.guomin_food_item_name}</div>

                    <div style={{ marginTop: 16 }}>
                        <p>其他禁忌食材</p>
                        <Space>
                            <Select placeholder="选择食材分类" onChange={(v: string) => {
                                baseAxiosNoInfo('/cooking_center/global/food_item_list', {
                                    params: {
                                        food_type_id: v
                                    }
                                }).then(((res: any) => {
                                    res && setFoods(res)
                                }))
                            }}>
                                {types.map((el: any) => <Option key={el.food_type_id} value={el.food_type_id}>{el.food_type_name}</Option>)}
                            </Select>
                            <Select placeholder="选择食材" value={foodID1} style={{ minWidth: 120 }} mode="multiple" onChange={(v: string[]) => {
                                setFoodID1(v)
                            }} >
                                {foods.map((el: any) => <Option key={el.food_item_id} value={el.food_item_id}>{el.food_item_name}</Option>)}
                            </Select>
                        </Space>
                    </div>
                    <div style={{ marginTop: 16 }}>
                        <p>其他过敏食材</p>
                        <Space>
                            <Select placeholder="选择食材分类" onChange={(v: string) => {
                                baseAxiosNoInfo('/cooking_center/global/food_item_list', {
                                    params: {
                                        food_type_id: v
                                    }
                                }).then(((res: any) => {
                                    res && setFoods(res)
                                }))
                            }}>
                                {types.map((el: any) => <Option key={el.food_type_id} value={el.food_type_id}>{el.food_type_name}</Option>)}
                            </Select>
                            <Select placeholder="选择食材" value={foodID2} style={{ minWidth: 120 }} mode="multiple" onChange={(v: string[]) => {
                                setFoodID2(v)
                            }} >
                                {foods.map((el: any) => <Option key={el.food_item_id} value={el.food_item_id}>{el.food_item_name}</Option>)}
                            </Select>
                        </Space>
                    </div>
                    <div style={{ marginTop: 16 }}>
                        <Input value={otherException} onChange={(e: any) => {
                            setOtherException(e.target.value)
                        }} placeholder="备注" />
                    </div>
                    <div style={{ marginTop: 16 }}>
                        <Button size="small" type="primary" onClick={() => {
                            editPg()
                        }}>保存</Button>
                    </div>
                </Fragment>}



            </Col>
            <Col span="10">
                <h4 style={{ marginBottom: 20, fontSize: 20 }}>排餐</h4>


                <Table pagination={false} dataSource={[
                    { mealName: '早餐(8:00)', meal: oneDayMeals.menu_info.zao_can, mealKey: 'zao_can' },
                    { mealName: '加餐(10:00)', meal: oneDayMeals.menu_info.jia_can, mealKey: 'jia_can' },
                    { mealName: '午餐(12:00)', meal: oneDayMeals.menu_info.wu_can, mealKey: 'wu_can' },
                    { mealName: '间餐(15:00)', meal: oneDayMeals.menu_info.jian_can, mealKey: 'jian_can' },
                    { mealName: '晚餐(18:00)', meal: oneDayMeals.menu_info.wan_can, mealKey: 'wan_can' },
                    { mealName: '宵夜(20:00)', meal: oneDayMeals.menu_info.xiaoye, mealKey: 'xiaoye' },
                ]}>
                    <Column title="餐次" dataIndex="mealName"></Column>
                    <Column title={oneDayMeals.menu_date} render={(v: any) => {
                        return <Fragment><ul style={{ padding: 0, margin: 0, listStyle: 'none' }}>
                            {v.meal.map((el: any, index: number) => <li style={{ marginBottom: 6 }}><Space>
                                {el.has_repeat === 1 && <ExclamationOutlined style={{ color: 'blue' }} title="近3天内有重复" />}
                                {el.has_guopin_and_jinji === 1 && <ExclamationOutlined style={{ color: 'red' }} title="过敏或禁忌食材" />}
                                {el.is_high_price === 1 && <span style={{ color: 'orange' }}>(贵)</span>}
                                <span>{el.menu_item_name}</span>
                                {el.sugar_status === 1 && <span style={{ color: '#a6a800' }}>（去糖）</span>}
                                {el.sugar_status === 2 && <span style={{ color: '#a6a800' }}>（少糖）</span>}
                                {el.sugar_status === 3 && <span style={{ color: '#a6a800' }}>（多糖）</span>}
                                {el.salt_status === 1 && <span style={{ color: '#a6a800' }}>（去盐）</span>}
                                {el.salt_status === 2 && <span style={{ color: '#a6a800' }}>（少盐）</span>}
                                {el.salt_status === 3 && <span style={{ color: '#a6a800' }}>（多盐）</span>}
                                <span style={{ color: '#a6a800' }}>{el.preference_desc}</span>
                                {/* <span>{el.menu_item_count}</span> */}
                                <Input style={{ width: 40 }} size="small" value={el.menu_item_count} onChange={(e: any) => {
                                    let num = Number(e.target.value)
                                    if (!isNaN(num)) {
                                        let d = _.cloneDeep(oneDayMeals)
                                        d.menu_info[v.mealKey][index].menu_item_count = num
                                        // 同步高价菜品数量
                                        // syncHighNum(d)
                                        setOneDayMeals(d)
                                    } else {
                                        message.error('必须填写数字')
                                    }
                                }} />
                                <Button size="small" onClick={() => {
                                    setCurrentCpIndex(index)
                                    setCurrentMealKey(v.mealKey)
                                    let d = _.cloneDeep(oneDayMeals)
                                    setSugarStatus(d.menu_info[v.mealKey][index].sugar_status)
                                    setSaltStatus(d.menu_info[v.mealKey][index].salt_status)
                                    setPreferenceDesc(d.menu_info[v.mealKey][index].preference_desc)
                                    setVisibled(true)
                                }}>偏好</Button>
                                <DeleteOutlined style={{ cursor: 'pointer' }} onClick={() => {
                                    let d = _.cloneDeep(oneDayMeals)
                                    d.menu_info[v.mealKey].splice(index, 1)
                                    setOneDayMeals(d)
                                }} />
                            </Space></li>
                            )}
                        </ul>
                            <div style={{ marginBottom: 14 }}>
                                <Select virtual={false} allowClear placeholder="选择菜品分类" style={{ maxWidth: 140, marginRight: 14 }} onChange={(v: string) => {
                                    // 查询该分类下的菜品
                                    baseAxiosNoInfo('/cooking_center/global/menu_item_list_by_type_id', {
                                        params: {
                                            menu_type_id: v
                                        }
                                    }).then((res: any) => {
                                        res && setFoodList(res)
                                    })
                                }}>
                                    {foodTypeList.map(el => <Option value={el.menu_type_id}>{el.menu_type_name}</Option>)}
                                </Select>
                                <Select
                                    allowClear
                                    showSearch
                                    virtual={false}
                                    style={{ maxWidth: 140 }}
                                    placeholder="选择菜品"
                                    filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                                    onChange={(v: any) => {
                                        setFood(foodList.find(el => el.menu_item_id === v))
                                    }}
                                >
                                    {foodList.map(el => <Option value={el.menu_item_id}>{el.menu_item_name}</Option>)}
                                </Select>
                            </div>
                            <Button style={{ marginTop: 2 }} size="small" onClick={() => {
                                if (food) {

                                    let d = _.cloneDeep(oneDayMeals)

                                    if (d.menu_info[v.mealKey].some((el: any) => el.menu_item_id === food.menu_item_id)) {
                                        message.error('菜品已存在该餐次当中')
                                        return
                                    }

                                    d.menu_info[v.mealKey].push({
                                        menu_item_name: food?.menu_item_name,
                                        menu_item_id: food?.menu_item_id,
                                        menu_item_count: 1,
                                        is_high_price: food.is_high_price,
                                        salt_status: 0,
                                        sugar_status: 0,
                                        setPreferenceDesc: ''
                                    })

                                    setOneDayMeals(d)
                                } else {
                                    message.error('必须先选择菜品分类和菜品')
                                }
                            }}>添加菜品</Button>
                        </Fragment>
                    }}></Column>))
                </Table>
            </Col>
            <Col span="3">
                <h4 style={{ fontWeight: 'bold' }}>门店当天全部已下单菜品</h4>
                <ul style={{ padding: 0, margin: 0, listStyle: 'none' }}>
                    {oneDayMeals.already_order_and_add_info.order.map((el: any) => <li><Space>{el.is_high_price === 1 && <span style={{ color: 'orange' }}>(贵)</span>}<span>{el.menu_item_name}（{el.menu_item_count}）</span></Space></li>)}
                </ul>
                <h4 style={{ marginTop: 30, fontWeight: 'bold' }}>客户当天新添加菜品</h4>
                <ul style={{ padding: 0, margin: 0, listStyle: 'none' }}>
                    {oneDayMeals.already_order_and_add_info.add.map((el: any) => <li><Space>{el.is_high_price === 1 && <span style={{ color: 'orange' }}>(贵)</span>}<span>{el.menu_item_name}（{el.menu_item_count}）</span></Space></li>)}
                </ul>
            </Col>
            <Col span="7" style={{ overflowX: 'scroll' }}>
                <h4 style={{ marginBottom: 20, fontSize: 20 }}>客户餐单</h4>

                <div style={{ minWidth: 1000 }}>
                    <Space className="food-jd-tabs" style={{ marginBottom: 20 }}>
                        {reviewData.map((el: any, index: number) => <Button style={{
                            background: index === currentStageIndex ? '#2a2abc' : 'none',
                            color: index === currentStageIndex ? '#fff' : '#333',
                        }} onClick={() => {
                            setCurrentStageIndex(index)
                        }}>第{index + 1}阶段</Button>)}
                    </Space>
                    <Table pagination={false} dataSource={[
                        { mealName: '早餐(8:00)' },
                        { mealName: '加餐(10:00)' },
                        { mealName: '午餐(12:00)' },
                        { mealName: '间餐(15:00)' },
                        { mealName: '晚餐(18:00)' },
                        { mealName: '宵夜(20:00)' }
                    ]}>
                        <Column title="餐次" dataIndex="mealName"></Column>

                        {reviewData[currentStageIndex] && reviewData[currentStageIndex].detail.map(((el: any) => <Column title={el.date} render={(row: any) => {
                            const oli = (el: any) => <li><Space>
                                {el.is_high_price === 1 && <span style={{ color: 'orange' }}>(贵)</span>}
                                {el.is_add === 1 && <span style={{ color: 'blue' }}> 加 </span>}
                                <span>{el.menu_item_name}（{el.menu_item_count}）</span>
                                {el.sugar_status === 1 && <span style={{ color: '#a6a800' }}>（去糖）</span>}
                                {el.sugar_status === 2 && <span style={{ color: '#a6a800' }}>（少糖）</span>}
                                {el.sugar_status === 3 && <span style={{ color: '#a6a800' }}>（多糖）</span>}
                                {el.salt_status === 1 && <span style={{ color: '#a6a800' }}>（去盐）</span>}
                                {el.salt_status === 2 && <span style={{ color: '#a6a800' }}>（少盐）</span>}
                                {el.salt_status === 3 && <span style={{ color: '#a6a800' }}>（多盐）</span>}
                                <span style={{ color: '#a6a800' }}>{el.preference_desc}</span>
                            </Space>
                            </li>
                            if (row.mealName === '早餐(8:00)') {
                                return <ul style={{ padding: 0, margin: 0, listStyle: 'none' }}>
                                    {el.meals1.map((el: any) => oli(el))}
                                </ul>
                            }
                            if (row.mealName === '加餐(10:00)') {
                                return <ul style={{ padding: 0, margin: 0, listStyle: 'none' }}>
                                    {el.meals2.map((el: any) => oli(el))}
                                </ul>
                            }
                            if (row.mealName === '午餐(12:00)') {
                                return <ul style={{ padding: 0, margin: 0, listStyle: 'none' }}>
                                    {el.meals3.map((el: any) => oli(el))}
                                </ul>
                            }
                            if (row.mealName === '间餐(15:00)') {
                                return <ul style={{ padding: 0, margin: 0, listStyle: 'none' }}>
                                    {el.meals4.map((el: any) => oli(el))}
                                </ul>
                            }
                            if (row.mealName === '晚餐(18:00)') {
                                return <ul style={{ padding: 0, margin: 0, listStyle: 'none' }}>
                                    {el.meals5.map((el: any) => oli(el))}
                                </ul>
                            }
                            if (row.mealName === '宵夜(20:00)') {
                                return <ul style={{ padding: 0, margin: 0, listStyle: 'none' }}>
                                    {el.meals6.map((el: any) => oli(el))}
                                </ul>
                            }
                        }}></Column>))}
                    </Table>
                </div>
            </Col>
        </Row>
        {/* 设置菜品偏好 */}
        <Modal title="菜品偏好设置" visible={phVisibled} onOk={phOk} onCancel={(phCancel)} width={300}>
            <div>
                <h4>糖</h4>
                <Space style={{ marginBottom: 20 }}>
                    <Radio.Group value={sugarStatus} onChange={(e: any) => {
                        setSugarStatus(e.target.value)
                    }}>
                        <Radio value={0}>默认</Radio>
                        <Radio value={1}>去糖</Radio>
                        <Radio value={2}>少糖</Radio>
                        <Radio value={3}>多糖</Radio>
                    </Radio.Group>
                </Space>
                <h4>盐</h4>
                <Space style={{ marginBottom: 20 }}>
                    <Radio.Group value={saltStatus} onChange={(e: any) => {
                        setSaltStatus(e.target.value)
                    }}>
                        <Radio value={0}>默认</Radio>
                        <Radio value={1}>去盐</Radio>
                        <Radio value={2}>少盐</Radio>
                        <Radio value={3}>多盐</Radio>
                    </Radio.Group>
                </Space>
                <h4>备注</h4>
                <Input placeholder="备注，可将偏好内容写在备注里" value={preferenceDesc} onChange={(e) => { setPreferenceDesc(e.target.value) }} />
            </div>
        </Modal>
    </div>
}